import * as moment from "moment";

export class DateConverter {
  static parseDates(v: any) {}

  static toLocalTime(date) {
    return moment(date).format("YYYY/MM/DD HH:mm:ss");
  }
}
